import { render, staticRenderFns } from "./ReceiverInfo.vue?vue&type=template&id=1671c19b&scoped=true&"
import script from "./ReceiverInfo.vue?vue&type=script&lang=ts&"
export * from "./ReceiverInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiverInfo.vue?vue&type=style&index=0&id=1671c19b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671c19b",
  null
  
)

export default component.exports